export default {
  countryCode: 'ID',
  regionLinks: [
    {
      title: 'Bali',
    },
    {
      title: 'Jakarta',
    },
  ],
};
